import { z } from 'zod';

export const DIAS_SEMANA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'] as const;
export type DiaSemana = (typeof DIAS_SEMANA)[number];

export const ROTULO_DIA: Record<DiaSemana, string> = {
  dom: 'Domingo',
  seg: 'Segunda',
  ter: 'Terça',
  qua: 'Quarta',
  qui: 'Quinta',
  sex: 'Sexta',
  sab: 'Sábado',
};

const hora = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Use o formato HH:MM');
const periodo = z
  .object({ abre: hora, fecha: hora })
  .refine((p) => p.abre < p.fecha, 'O horário de fechar precisa ser depois do de abrir')
  .nullable();

const iaSchema = z.object({ ativa: z.boolean(), duvidasNaFila: z.boolean() });

export const configuracoesSchema = z.object({
  ia: iaSchema,
  horario: z.object({
    dias: z.object({
      dom: periodo,
      seg: periodo,
      ter: periodo,
      qua: periodo,
      qui: periodo,
      sex: periodo,
      sab: periodo,
    }),
    mensagemFora: z.string().trim().min(1, 'Escreva a mensagem de fora do horário').max(500),
  }),
  fila: z
    .object({
      atencaoMin: z.number().int().min(1).max(240),
      criticoMin: z.number().int().min(2).max(480),
    })
    .refine(
      (f) => f.atencaoMin < f.criticoMin,
      'O tempo do vermelho precisa ser maior que o do amarelo',
    ),
});

export type Configuracoes = z.infer<typeof configuracoesSchema>;

export const editarConfiguracoesSchema = configuracoesSchema
  .extend({ ia: iaSchema.partial() })
  .partial();
export type EditarConfiguracoes = z.infer<typeof editarConfiguracoesSchema>;

export const CONFIGURACOES_PADRAO: Configuracoes = {
  ia: { ativa: true, duvidasNaFila: true },
  horario: {
    dias: {
      dom: null,
      seg: { abre: '07:00', fecha: '16:30' },
      ter: { abre: '07:00', fecha: '16:30' },
      qua: { abre: '07:00', fecha: '16:30' },
      qui: { abre: '07:00', fecha: '16:30' },
      sex: { abre: '07:00', fecha: '16:30' },
      sab: null,
    },
    mensagemFora: 'Nosso time volta no próximo dia útil às 7h, já deixei tudo anotado aqui! 😊',
  },
  fila: { atencaoMin: 5, criticoMin: 15 },
};

export function dentroDoHorario(c: Configuracoes, agora = new Date()): boolean {
  const partes = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(agora);
  const pega = (t: string) => partes.find((p) => p.type === t)?.value ?? '';
  const dia = {
    Sun: 'dom',
    Mon: 'seg',
    Tue: 'ter',
    Wed: 'qua',
    Thu: 'qui',
    Fri: 'sex',
    Sat: 'sab',
  }[pega('weekday')] as DiaSemana;
  const p = c.horario.dias[dia];
  if (!p) return false;
  const hhmm = `${pega('hour')}:${pega('minute')}`;
  return hhmm >= p.abre && hhmm < p.fecha;
}
